import React from 'react';
import { User, CheckCircle, Clock, PoundSterling, BookOpen, Star } from 'lucide-react';
import './WhyChooseUs.css';

const WhyChooseUs = () => {

  const features = [
    {
      icon: User,
      title: "Personalised one-on-one sessions",
      description: "Dedicated tutors focused entirely on your learning needs and pace",
      color: "var(--primary-blue)"
    },
    {
      icon: CheckCircle,
      title: "Verified and experienced tutors",
      description: "All our tutors are thoroughly vetted and have proven track records",
      color: "var(--dark-blue)"
    },
    {
      icon: Clock,
      title: "Flexible online classes",
      description: "Schedule lessons at times that work best for your lifestyle",
      color: "var(--primary-blue)"
    },
    {
      icon: Star,
      title: "Free assessment and demo classes",
      description: "Experience our teaching quality before making any commitment",
      color: "var(--dark-blue)"
    },
    {
      icon: BookOpen,
      title: "Interactive lessons",
      description: "Engaging sessions with digital whiteboards and real-time feedback",
      color: "var(--primary-blue)"
    },
    {
      icon: PoundSterling,
      title: "Starting from £6.90 per hour",
      description: "Premium quality education at affordable prices with no hidden fees",
      color: "var(--dark-blue)"
    }
  ];

  return (
    <section className="why-choose-us section" id="why-choose-us">
      <div className="container">
        <div className="section-header">
          <h2 className="section-title">
            Why Choose <span className="gradient-text">Us?</span>
          </h2>
          <p className="section-description">
            Discover what makes our tutoring service the perfect choice for your academic success
          </p>
        </div>

        <div className="features-grid">
          {features.map((feature, index) => (
            <div
              key={index}
              className="feature-card premium-card"
            >
              <div className="feature-icon-container">
                <feature.icon 
                  className="feature-icon" 
                  style={{ color: feature.color }}
                />
              </div>
              
              <h3 className="feature-title">{feature.title}</h3>
              <p className="feature-description">{feature.description}</p>
              
            </div>
          ))}
        </div>

        <div className="guarantee-section">
          <div className="guarantee-card">
            <div className="guarantee-icon">
              <CheckCircle className="check-icon" />
            </div>
            <div className="guarantee-content">
              <h3 className="guarantee-title">No Hidden Fees Guarantee</h3>
              <p className="guarantee-text">
                Complete transparency in pricing - you only pay for the lessons you choose
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhyChooseUs;
